import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import {
  ITableColumnConfig,
  ITableHeaderConfig,
} from 'src/app/components/tablecomponent/tablecomponent.constants';
import { VisualizerComponent } from 'src/app/modals/visualizer/visualizer.component';
import { VisualizererrorsComponent } from 'src/app/modals/visualizererrors/visualizererrors.component';
import { NfsFileModel } from 'src/models/nfsfile.model';
import { NfsListService } from 'src/repository/nfslist/nfslist.service';
import { NfsSendService } from 'src/repository/nfssend/nfssend.service';
import { DownloaderService } from 'src/services/download/downloader.service';
import { ModalserviceService } from 'src/services/modal/modalservice.service';
import { UploadService } from 'src/services/upload/upload.service';

@Component({
  selector: 'app-listfiles',
  templateUrl: './listfiles.component.html',
  styleUrls: ['./listfiles.component.scss'],
})
export class ListfilesComponent implements OnInit {
  public loading: boolean = false;
  public justerrors: boolean = false;
  public justnomodel: boolean = false;
  public justnotsended: boolean = false;

  private _list: NfsFileModel[] = [];
  public pageSize: number = 200;
  public currentPage: number = 1;
  public searchFileName: string = '';
  public searchChave: string = '';

  public month: string = String(moment().month() + 1);
  public year: string = String(moment().year());

  public _date: string = '';

  public configTable: ITableColumnConfig[] = [
    {
      key: 'sended',
      label: 'Enviada',
      size: '80px',
      columnsize: 50,
      alignment: 'center',
      booleanOption: { falseValue: false, trueValue: true },
    },
    {
      key: 'txt_file_name',
      label: 'Arquivo',
      size: '300px',
      columnsize: 7.5,
      alignment: 'left',
    },
    {
      key: 'xml_model',
      label: 'Modelo',
      size: '100px',
      columnsize: 7.5,
      alignment: 'left',
    },
    {
      key: 'location',
      label: 'Local',
      size: '1fr',
      columnsize: 7.5,
      alignment: 'left',
    },
    {
      key: 'date',
      label: 'data',
      size: '150px',
      columnsize: 7.5,
      alignment: 'left',
    },
  ];
  public TableHeaderConfig: ITableHeaderConfig = {
    background: 'var(--color-toptable)',
    color: 'var(--color-toptable-contrast)',
  };

  constructor(
    private nfslist: NfsListService,
    private uploadservice: UploadService,
    private nfssend: NfsSendService,
    private modal: ModalserviceService,
  ) {}

  ngOnInit(): void {
    this.init_data();
  }

  get date() {
    return this._date;
  }

  set date(date) {
    this._date = date;
  }

  ionViewDidEnter() {}

  get list(): NfsFileModel[] {
    let res = this._list.reverse();

    if (this.justerrors) res = this.filter_just_errors(res);
    if (this.justnomodel) res = this.filter_just_model_error(res);
    if (this.justnotsended) res = this.filter_just_not_sended(res);
    if (this.date) res = this.filter_just_date(res);
    if (this.searchFileName) res = this.filter_by_filename(res);

    // Paginação: retorna apenas os itens da página atual
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return res.slice(startIndex, endIndex);
  }

  get totalItems(): number {
    let res = [...this._list];

    if (this.justerrors) res = this.filter_just_errors(res);
    if (this.justnomodel) res = this.filter_just_model_error(res);
    if (this.justnotsended) res = this.filter_just_not_sended(res);
    if (this.date) res = this.filter_just_date(res);
    if (this.searchFileName) res = this.filter_by_filename(res);

    return res.length;
  }

  get totalItemsWithoutFilters(): number {
    return this._list.length;
  }

  get hasMoreItems(): boolean {
    return this.currentPage < this.totalPages;
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  get hasPreviousPage(): boolean {
    return this.currentPage > 1;
  }

  nextPage(): void {
    if (this.hasMoreItems) {
      this.currentPage++;
    }
  }

  previousPage(): void {
    if (this.hasPreviousPage) {
      this.currentPage--;
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  resetPagination(): void {
    this.currentPage = 1;
  }

  get table() {
    return `${this.month}_${this.year}`;
  }

  async downloadErrorFile(notsended: boolean = false) {
    try {
      const file = await this.nfssend.downloadErrors(this.table, notsended);
      const downloader = new DownloaderService();
      const namefile = notsended
        ? `xml_erros_não_enviados_${this.table}.zip`
        : `xml_erros_${this.table}.zip`;
      downloader.bufferDownload(file as ArrayBuffer, namefile);
    } catch (error) {
      console.error('Error downloading error file:', error);
    }
  }

  async init_data() {
    this.loading = true;
    this.resetPagination();
    try {
      console.log('Mes => ', this.month);
      console.log('Ano => ', this.year);

      this._list = await this.nfslist.all(this.table);
      console.log(this._list);
    } catch (error) {}
    this.loading = false;
  }

  async upload() {
    try {
      let value = await this.uploadservice.upload_file();
      await this.send(value);
    } catch (error) {
      console.log(error);
    }
  }

  async send(value) {
    this.loading = true;
    try {
      await this.nfssend.send(value.read_form_data());
    } catch (error) {}
    this.loading = false;
  }

  async resend() {
    this.loading = true;
    try {
      await this.nfssend.resend(this.table);
    } catch (error) {}
    this.loading = false;
  }

  async getItem(item: NfsFileModel) {
    // this.loading = true;
    try {
      let res = await this.nfslist.getXmlData(this.table, item);
      console.log('Data => ', res);
      if (res) {
        this.modal.show(VisualizerComponent, { data: res });
      }
    } catch (error) {}
    // this.loading = false;
  }

  async getItemByChave(chave: string) {
    // this.loading = true;
    try {
      let res = await this.nfslist.getXmlDataByChave(this.table, chave);
      console.log('Data => ', res);
      if (res) {
        this.modal.show(VisualizerComponent, { data: res });
      }
    } catch (error) {}
    // this.loading = false;
  }

  async searchByChave() {
    if (this.searchChave && this.searchChave.trim()) {
      await this.getItemByChave(this.searchChave.trim());
    }
  }

  filter_just_errors(list: NfsFileModel[]) {
    return list.filter((item) => item.xml_data_errors);
  }

  filter_just_model_error(list: NfsFileModel[]) {
    return list.filter((item) => !item.xml_model);
  }

  filter_just_not_sended(list: NfsFileModel[]) {
    return list.filter((item) => !item.sended);
  }

  filter_just_date(list: NfsFileModel[]) {
    return list.filter((item) =>
      moment(item.dtupdate, 'YY-MM-DD HH:mm:SS').isAfter(this.date),
    );
  }

  filter_by_filename(list: NfsFileModel[]) {
    return list.filter((item) =>
      item.txt_file_name
        ?.toLowerCase()
        .includes(this.searchFileName.toLowerCase()),
    );
  }

  async no_sended_report() {
    this.loading = true;
    try {
      let errors = this.filter_just_not_sended(this._list);
      errors = errors.map((item) =>
        NfsFileModel.fromJson({
          ...item,
          xml_data_errors: item.xml_data_errors || [
            'Arquivo Vazio/Erro de análise do arquivo',
          ],
        }),
      );
      let downloader = new DownloaderService();
      let data = errors.map((item) => item.toExcelValues());
      const excel = await downloader.toExcel(
        data,
        'Erros de Upload (Não enviados)',
        [30, 15, 40, 40, 40],
        ['Arquivo', 'Modelo', 'Erros', 'Localização', 'Data de Upload'],
      );
    } catch (error) {}
    this.loading = false;
  }

  async errors_report() {
    this.loading = true;
    try {
      let errors = this.filter_just_errors(this._list);
      console.log(errors);
      this.modal.show(VisualizererrorsComponent, {
        data: { items: errors, period: this.table },
      });
    } catch (error) {}
    this.loading = false;
  }
}
